import { ApiClient } from '../api-client';

const FeatureApi = ApiClient.service.feature;

const useFeatureApi = () => {
  return FeatureApi;
};

export { FeatureApi, useFeatureApi };
